import { render, staticRenderFns } from "./AprobacionModal.vue?vue&type=template&id=371b5d8c&scoped=true"
import script from "./AprobacionModal.vue?vue&type=script&lang=js"
export * from "./AprobacionModal.vue?vue&type=script&lang=js"
import style0 from "./AprobacionModal.vue?vue&type=style&index=0&id=371b5d8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371b5d8c",
  null
  
)

export default component.exports